/* Emissões → Meus envios: planilhas importadas, links e documentos (GET /envios). */

import { api } from '../../core/api';
import { cat } from '../../core/estado';
import { dataHoraBR, esc, lista } from '../../core/formato';
import type { Envio, StatusEnvio, TipoEnvio } from '../../tipos/api';
import { carregar } from '../../ui/carregar';
import { emptyTable, loading, tableFoot } from '../../ui/componentes';
import type { Pagina } from '../pagina';

const TIPO: Record<TipoEnvio, string> = { planilha: 'Planilha', link: 'OneDrive/SharePoint', documentos: 'Documentos' };
const STATUS: Record<StatusEnvio, [string, string]> = {
  recebido: ['Recebido', 'infop'],
  em_processamento: ['Em processamento', 'infop'],
  concluido: ['Concluído', 'sucesso'],
  importado: ['Importado', 'sucesso'],
  parcial: ['Parcial', 'warnp'],
  erro: ['Erro', 'erro'],
};

const pillStatus = (st: StatusEnvio) => {
  const [rotulo, classe] = STATUS[st] || [st, 'grey'];
  return `<span class="pill ${classe}">${esc(rotulo)}</span>`;
};

const nomeCategoria = (slug: string) => cat().categorias.find((c) => c.slug === slug)?.nome || slug;
const nomeTipoDocumento = (id: string) => cat().tipos_documento?.find((t) => t.id === id)?.nome || id;

function tabelaEnvios(d: Envio[]): string {
  const l = lista<Envio>(d);
  const colunas = ['Data do envio', 'Tipo', 'Obra', 'Origem', 'Situação', 'Detalhe'];
  if (!l.length) return emptyTable(colunas, 'Nenhum envio ainda. Importe uma planilha ou envie documentos.');
  return `<div class="table-wrap"><table class="table">
    <thead><tr>${colunas.map((c) => `<th>${c}</th>`).join('')}</tr></thead>
    <tbody>${l.map((e) => `<tr>
      <td class="num">${dataHoraBR(e.created_at)}</td>
      <td><span class="pill grey">${esc(TIPO[e.tipo] || e.tipo)}</span>${
        e.categoria || e.tipo_documento ? `<div style="margin-top:4px"><small style="color:var(--muted)">${esc(e.categoria ? nomeCategoria(e.categoria) : nomeTipoDocumento(e.tipo_documento as string))}</small></div>` : ''}</td>
      <td>${esc(e.obra || '—')}</td>
      <td style="max-width:320px;word-break:break-word">${esc(e.origem)}</td>
      <td>${pillStatus(e.status)}</td>
      <td style="color:var(--muted);max-width:280px">${esc(e.mensagem || '')}</td>
    </tr>`).join('')}</tbody></table>${tableFoot(l.length)}</div>`;
}

export const envios: Pagina = {
  render: () => `
  <h1 class="page">Meus envios</h1>
  <p class="sub">Planilhas importadas e documentos enviados para processamento, com a situação de cada envio.</p>
  <div id="envLista">${loading()}</div>`,
  carregar: (tk) => carregar(tk, [{ id: 'envLista', busca: () => api<Envio[]>('GET', '/envios'), html: tabelaEnvios }]),
};
